(function () {

  if (window.__tk9SlideCartStaleGuardLoaded) return;
  window.__tk9SlideCartStaleGuardLoaded = true;

  var VERSION = "20260625-harness-upgrade-copy-v40";
    var CURRENT_SLIDE_CART_VERSION = "20260625-harness-upgrade-copy-v40";
  var DOGDAD_BRIDGE_ENABLED = false;
  var DOGDAD_END_ISO = "2026-06-23T04:59:59Z";
  var DOGDAD_HERO_IMAGE = "https://cdn.shopify.com/s/files/1/2715/4364/t/70/assets/tk9-dog-dad-lifestyle-hero-2026.jpg?v=1781796951";
  var DOGDAD_PDP_OFFER_TEXT = "Use DOGDAD for extra cart savings";

  function dogDadSaleActive() {
    if (!DOGDAD_BRIDGE_ENABLED) return false;
    var now = Date.now();
    var start = Date.parse("2026-06-18T05:00:00Z");
    var end = Date.parse(DOGDAD_END_ISO);
    return isFinite(start) && isFinite(end) && now >= start && now <= end;
  }

  function countdownParts() {
    var end = Date.parse(DOGDAD_END_ISO);
    var remaining = Math.max(0, end - Date.now());
    var totalMinutes = Math.floor(remaining / 60000);
    var days = Math.floor(totalMinutes / 1440);
    var hours = Math.floor((totalMinutes % 1440) / 60);
    var minutes = totalMinutes % 60;
    return {
      days: days < 10 ? "0" + days : String(days),
      hours: hours < 10 ? "0" + hours : String(hours),
      minutes: minutes < 10 ? "0" + minutes : String(minutes)
    };
  }

  function injectDogDadBridgeCss() {
    if (document.getElementById("tk9-dogdad-bridge-css")) return;
    var style = document.createElement("style");
    style.id = "tk9-dogdad-bridge-css";
    style.textContent = [
      ".tk9-dogdad-bridge-header{position:relative;z-index:30;background:#162846;color:#fff;font-family:inherit;border-bottom:1px solid rgba(255,255,255,.16)}",
      ".tk9-dogdad-bridge-header *{box-sizing:border-box}",
      ".tk9-dogdad-bridge-header__inner{display:flex;align-items:center;justify-content:center;gap:14px;min-height:44px;width:100%;padding:7px 18px;color:inherit;text-decoration:none}",
      ".tk9-dogdad-bridge-header__label{display:inline-flex;align-items:center;min-height:25px;padding:5px 10px;border-radius:3px;background:#ffc336;color:#071320;font-size:12px;font-weight:950;line-height:1;text-transform:uppercase;white-space:nowrap}",
      ".tk9-dogdad-bridge-header__proof{display:inline-flex;align-items:center;gap:6px;min-height:25px;padding:4px 0;color:#fff;font-size:12px;font-weight:900;line-height:1;white-space:nowrap}",
      ".tk9-dogdad-bridge-header__stars{color:#ffc336;font-size:13px;text-shadow:0 1px 0 rgba(0,0,0,.18)}",
      ".tk9-dogdad-bridge-header__offer{font-size:15px;font-weight:850;line-height:1.15;text-align:center;white-space:nowrap}",
      ".tk9-dogdad-bridge-header__offer strong{color:#ffc336;font-weight:950}",
      ".tk9-dogdad-bridge-header__offer-mobile{display:none}",
      ".tk9-dogdad-bridge-header__timer{display:inline-flex;align-items:center;gap:5px;min-height:30px;padding:4px 7px;border:1px solid rgba(255,255,255,.2);border-radius:5px;background:rgba(255,255,255,.1);font-size:12px;font-weight:800;line-height:1;white-space:nowrap}",
      ".tk9-dogdad-bridge-header__time{display:inline-flex;align-items:baseline;gap:1px;color:rgba(255,255,255,.86);font-size:10px;font-weight:850}",
      ".tk9-dogdad-bridge-header__time strong{color:#fff;font-size:13px;font-weight:950}",
      ".tk9-dogdad-bridge-header__cta{display:inline-flex;align-items:center;justify-content:center;min-height:30px;padding:7px 14px;border-radius:4px;background:#2f855a;color:#fff;font-size:12px;font-weight:950;line-height:1;text-transform:uppercase;white-space:nowrap}",
      ".tk9-dogdad-bridge-header__cta-mobile{display:none}",
      ".tk9-dogdad-bridge-hero{position:relative;overflow:hidden;min-height:min(660px,calc(100vh - 84px));background:#121a22;color:#fff}",
      ".tk9-dogdad-bridge-hero *{box-sizing:border-box}",
      ".tk9-dogdad-bridge-hero__media,.tk9-dogdad-bridge-hero__shade{position:absolute;inset:0}",
      ".tk9-dogdad-bridge-hero__media img{display:block;width:100%;height:100%;object-fit:cover;object-position:64% center}",
      ".tk9-dogdad-bridge-hero__shade{background:linear-gradient(90deg,rgba(7,13,22,.9) 0%,rgba(7,13,22,.72) 34%,rgba(7,13,22,.18) 64%,rgba(7,13,22,.02) 100%)}",
      ".tk9-dogdad-bridge-hero__inner{position:relative;z-index:1;display:flex;align-items:center;max-width:1440px;min-height:inherit;margin:0 auto;padding:58px 44px 48px}",
      ".tk9-dogdad-bridge-hero__content{width:min(100%,720px)}",
      ".tk9-dogdad-bridge-hero__eyebrow{display:inline-flex;width:fit-content;margin:0 0 16px;padding:7px 11px;border-radius:3px;background:#ffc336;color:#071320;font-size:12px;font-weight:950;line-height:1;text-transform:uppercase;box-shadow:0 10px 22px rgba(0,0,0,.16)}",
      ".tk9-dogdad-bridge-hero h1{max-width:680px;margin:0;color:#fff;font-size:clamp(54px,6.3vw,88px);line-height:.98;font-weight:950;letter-spacing:0}",
      ".tk9-dogdad-bridge-hero__lead{max-width:560px;margin:16px 0 0;color:rgba(255,255,255,.92);font-size:clamp(18px,1.55vw,22px);line-height:1.26;font-weight:800}",
      ".tk9-dogdad-bridge-hero__cta{display:inline-flex;align-items:center;justify-content:center;min-width:194px;min-height:52px;margin-top:24px;padding:15px 26px;border-radius:6px;background:#fff;color:#071320;font-size:16px;font-weight:950;line-height:1;text-decoration:none;box-shadow:0 16px 34px rgba(0,0,0,.2)}",
      ".tk9-dogdad-bridge-hero__proof{display:flex;flex-wrap:wrap;gap:12px;margin-top:16px}",
      ".tk9-dogdad-bridge-hero__proof span{display:inline-flex;align-items:center;gap:5px;min-height:22px;padding:0;border:0;background:transparent;color:rgba(255,255,255,.86);font-size:12px;font-weight:850;line-height:1;white-space:nowrap}",
      ".tk9-dogdad-bridge-hero__proof strong{color:#ffc336;font-weight:950}",
      ".tk9-dogdad-bridge-hide{display:none!important}",
      ".tk9-slide-cart__sale-timer.tk9-dogdad-bridge-cart-timer{display:inline-flex;align-items:center;gap:4px;min-height:26px;padding:4px 7px;border:1px solid #d9e2f1;border-radius:6px;background:#f6f9ff;color:#12213a;font-size:11px;font-weight:900;line-height:1;white-space:nowrap}",
      ".tk9-slide-cart__sale-timer.tk9-dogdad-bridge-cart-timer span{color:#667085;font-size:9px;text-transform:uppercase}",
      ".tk9-slide-cart__sale-timer.tk9-dogdad-bridge-cart-timer b{color:#12213a;font-size:11px;font-weight:950}",
      ".tk9-dogdad-pdp-offer{box-sizing:border-box;display:grid;grid-template-columns:minmax(0,1fr) auto;gap:12px;align-items:center;width:100%;margin:10px 0 0;padding:12px 14px;border:1px solid #f1d28a;border-radius:8px;background:#fff8df;color:#13213a;box-shadow:0 10px 22px rgba(19,33,58,.06)}",
      ".tk9-dogdad-pdp-offer *{box-sizing:border-box}.tk9-dogdad-pdp-offer span{display:block;margin-bottom:4px;color:#925f11;font-size:11px;font-weight:950;line-height:1;text-transform:uppercase}.tk9-dogdad-pdp-offer strong{display:block;color:#13213a;font-size:15px;font-weight:950;line-height:1.16}.tk9-dogdad-pdp-offer p{margin:5px 0 0;color:#526174;font-size:12.5px;font-weight:760;line-height:1.28}.tk9-dogdad-pdp-offer b{display:inline-flex;align-items:center;justify-content:center;min-height:34px;padding:8px 10px;border-radius:6px;background:#13213a;color:#fff;font-size:11px;font-weight:950;line-height:1;text-transform:uppercase;white-space:nowrap}",
      "@media(max-width:760px){.tk9-dogdad-bridge-header{background:linear-gradient(90deg,#111f36 0%,#162846 56%,#0f253f 100%);box-shadow:inset 0 -1px 0 rgba(255,255,255,.14)}.tk9-dogdad-bridge-header__inner{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;column-gap:6px;row-gap:3px;min-height:42px;padding:6px 8px;text-align:center}.tk9-dogdad-bridge-header__proof{display:none}.tk9-dogdad-bridge-header__label{order:1;min-height:18px;padding:3px 7px;border-radius:4px;font-size:9px;box-shadow:0 6px 14px rgba(255,195,54,.14)}.tk9-dogdad-bridge-header__offer{order:2;min-width:0;max-width:100%;overflow:hidden;color:rgba(255,255,255,.95);font-size:11.2px;line-height:1.12;text-align:center;text-overflow:ellipsis;white-space:nowrap}.tk9-dogdad-bridge-header__offer-desktop{display:none}.tk9-dogdad-bridge-header__offer-mobile{display:inline}.tk9-dogdad-bridge-header__timer{order:3;flex:0 0 auto;justify-content:center;gap:3px;min-height:22px;padding:2px 7px;font-size:10px}.tk9-dogdad-bridge-header__timer>span:first-child{display:none}.tk9-dogdad-bridge-header__cta{display:none}.tk9-dogdad-bridge-header__cta-desktop{display:none}.tk9-dogdad-bridge-header__cta-mobile{display:inline}.tk9-dogdad-bridge-hero{min-height:460px}.tk9-dogdad-bridge-hero__media img{object-position:69% center}.tk9-dogdad-bridge-hero__shade{background:linear-gradient(180deg,rgba(7,13,22,.02) 0%,rgba(7,13,22,.28) 42%,rgba(7,13,22,.96) 100%)}.tk9-dogdad-bridge-hero__inner{align-items:flex-end;padding:174px 18px 24px}.tk9-dogdad-bridge-hero__content{max-width:340px}.tk9-dogdad-bridge-hero__eyebrow{margin-bottom:10px;font-size:10px}.tk9-dogdad-bridge-hero h1{font-size:43px;line-height:1}.tk9-dogdad-bridge-hero__lead{max-width:330px;margin-top:10px;font-size:15px;line-height:1.28}.tk9-dogdad-bridge-hero__cta{width:auto;min-width:166px;min-height:46px;margin-top:15px;padding:13px 20px;font-size:13px}.tk9-dogdad-bridge-hero__proof{gap:9px 12px;margin-top:11px}.tk9-dogdad-bridge-hero__proof span{min-height:18px;font-size:10px}.tk9-dogdad-bridge-hero__proof span:nth-child(2){display:none}.tk9-slide-cart__sale-timer.tk9-dogdad-bridge-cart-timer{max-width:120px;gap:3px;padding:3px 5px;font-size:10px}.tk9-slide-cart__sale-timer.tk9-dogdad-bridge-cart-timer span{display:none}.tk9-dogdad-pdp-offer{grid-template-columns:1fr;margin:10px 0 0;padding:11px 12px}.tk9-dogdad-pdp-offer b{display:none}.tk9-dogdad-pdp-offer strong{font-size:14px}.tk9-dogdad-pdp-offer p{font-size:12px}}",
      ".tk9-pdp-setup-sale{display:grid;grid-template-columns:1fr;gap:12px;align-items:stretch;width:100%;margin:12px 0 14px;padding:15px;border:1px solid rgba(20,33,55,.14);border-left:4px solid #f2b84b;border-radius:8px;background:linear-gradient(135deg,rgba(255,248,225,.96) 0%,rgba(246,250,255,.98) 52%,#fff 100%);color:#13213a;box-shadow:0 12px 28px rgba(19,33,58,.08);font-family:inherit}.tk9-pdp-setup-sale,.tk9-pdp-setup-sale *{box-sizing:border-box}.tk9-pdp-setup-sale__top,.tk9-pdp-setup-sale__footer{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px}.tk9-pdp-setup-sale__eyebrow,.tk9-pdp-setup-sale__code,.tk9-pdp-setup-sale__footer>span{display:inline-flex;align-items:center;width:fit-content;min-height:26px;border-radius:6px;font-size:11px;font-weight:950;line-height:1;letter-spacing:0;text-transform:uppercase;white-space:nowrap}.tk9-pdp-setup-sale__eyebrow{padding:0;color:#7b4a00}.tk9-pdp-setup-sale__code{padding:7px 9px;background:#13213a;color:#fff;box-shadow:0 8px 18px rgba(19,33,58,.14)}.tk9-pdp-setup-sale__body strong{display:block;max-width:36rem;color:#111827;font-size:17px;font-weight:950;line-height:1.14;letter-spacing:0}.tk9-pdp-setup-sale__body p{max-width:44rem;margin:7px 0 0;color:#45546a;font-size:13px;font-weight:740;line-height:1.38}.tk9-pdp-setup-sale__steps{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:7px}.tk9-pdp-setup-sale__steps span{display:grid;grid-template-columns:auto minmax(0,1fr);gap:7px;align-items:start;min-height:54px;padding:9px;border:1px solid rgba(19,33,58,.1);border-radius:7px;background:rgba(255,255,255,.78);color:#23324a;font-size:11.5px;font-weight:830;line-height:1.22;text-transform:none}.tk9-pdp-setup-sale__steps i{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#0f766e;color:#fff;font-size:10px;font-style:normal;font-weight:950;line-height:1}.tk9-pdp-setup-sale__footer{padding-top:2px}.tk9-pdp-setup-sale__footer>span{min-height:24px;padding:6px 8px;background:#e9f7f4;color:#0f665f}.tk9-pdp-setup-sale__footer small{min-width:0;color:#5a697d;font-size:11.5px;font-weight:760;line-height:1.24}",
      ".tk9-pdp-setup-sale .tk9-pdp-setup-sale__steps{grid-template-columns:1fr;gap:6px}.tk9-pdp-setup-sale .tk9-pdp-setup-sale__steps span{align-items:center;min-height:0;padding:8px 9px;font-size:12px}",
      "@media(max-width:740px){.tk9-pdp-setup-sale{gap:11px;margin:11px 0 13px;padding:13px;border-left-width:3px}.tk9-pdp-setup-sale__top,.tk9-pdp-setup-sale__footer{align-items:flex-start;flex-direction:column}.tk9-pdp-setup-sale__body strong{font-size:15px;line-height:1.18}.tk9-pdp-setup-sale__body p{font-size:12.5px;line-height:1.36}.tk9-pdp-setup-sale__steps{grid-template-columns:1fr;gap:6px}.tk9-pdp-setup-sale__steps span{min-height:0;padding:8px;font-size:11.5px}.tk9-pdp-setup-sale__footer small{font-size:11px}}",
      ".tk9-pdp-promo-strip{position:relative;isolation:isolate;display:grid;grid-template-columns:auto minmax(0,1fr) auto auto;gap:10px;align-items:center;width:100%;min-height:50px;margin:10px 0 12px;padding:8px 10px;overflow:hidden;border:1px solid rgba(214,145,23,.34);border-radius:8px;background:linear-gradient(120deg,rgba(255,209,102,.28),rgba(255,255,255,.92) 40%,#fff8e6 100%);color:#172033;box-shadow:0 10px 24px rgba(146,95,17,.1);font-family:inherit}.tk9-pdp-promo-strip::after{content:'';position:absolute;inset:-80% auto -80% -30%;z-index:-1;width:42%;transform:rotate(16deg);background:linear-gradient(90deg,rgba(255,255,255,0),rgba(255,209,102,.42),rgba(255,255,255,0))}.tk9-pdp-promo-strip__mark{display:block;width:9px;height:32px;border-radius:999px;background:linear-gradient(180deg,#ffd166,#f59e0b);box-shadow:0 0 0 3px rgba(255,209,102,.14)}.tk9-pdp-promo-strip__copy{min-width:0}.tk9-pdp-promo-strip .tk9-pdp-promo-strip__copy span{display:block;margin:0 0 2px;color:#9a6200;font-size:10px;font-weight:950;line-height:1;letter-spacing:0;text-transform:uppercase;white-space:nowrap}.tk9-pdp-promo-strip__copy strong{display:block;overflow:hidden;color:#172033;font-size:13px;font-weight:920;line-height:1.16;letter-spacing:0;text-overflow:ellipsis}.tk9-pdp-promo-strip__ends,.tk9-pdp-promo-strip__code{display:inline-flex;align-items:center;justify-content:center;min-height:30px;border-radius:7px;font-size:10.5px;font-weight:950;line-height:1;letter-spacing:0;text-transform:uppercase;white-space:nowrap}.tk9-pdp-promo-strip__ends{padding:0 8px;border:1px solid rgba(154,98,0,.18);background:rgba(255,255,255,.68);color:#7a4b10}.tk9-pdp-promo-strip__code{padding:0 10px;background:#f2b84b;color:#111827;text-decoration:none;box-shadow:0 8px 18px rgba(214,145,23,.18)}",
      "@media(max-width:640px){.tk9-pdp-promo-strip{grid-template-columns:auto minmax(0,1fr) auto;gap:8px;min-height:54px;padding:8px 9px}.tk9-pdp-promo-strip__mark{height:34px}.tk9-pdp-promo-strip__copy strong{display:-webkit-box;overflow:hidden;font-size:12px;line-height:1.18;-webkit-box-orient:vertical;-webkit-line-clamp:2}.tk9-pdp-promo-strip__ends{display:none}.tk9-pdp-promo-strip__code{min-height:32px;padding:0 9px;font-size:10px}}",
      "@media(max-width:760px){.tk9-dogdad-bridge-header__inner{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;column-gap:6px;row-gap:2px;min-height:44px;padding:6px 8px;text-align:center}.tk9-dogdad-bridge-header__label{order:0;flex:0 0 auto;min-height:18px;padding:3px 7px;border-radius:4px;font-size:9px;line-height:1;box-shadow:0 6px 14px rgba(255,195,54,.14)}.tk9-dogdad-bridge-header__offer{order:0;flex:0 1 auto;min-width:0;max-width:100%;overflow:hidden;text-align:center;text-overflow:ellipsis;white-space:nowrap}.tk9-dogdad-bridge-header__timer{order:0;flex:0 0 100%;display:inline-flex;align-items:center;justify-content:center;gap:4px;min-height:18px;padding:0;border:0;border-radius:0;background:transparent;color:rgba(255,255,255,.78);font-size:9.5px}.tk9-dogdad-bridge-header__timer>span:first-child{display:inline;color:rgba(255,255,255,.78);font-weight:850}.tk9-dogdad-bridge-header__time strong{font-size:10px}}",
      "@media(max-width:360px){.tk9-dogdad-bridge-header__inner{column-gap:5px;row-gap:2px;min-height:42px;padding-inline:7px}.tk9-dogdad-bridge-header__label{font-size:8px;padding-inline:6px}.tk9-dogdad-bridge-header__offer{font-size:10.4px}.tk9-dogdad-bridge-header__timer{gap:3px;min-height:18px;padding-inline:0;font-size:9px}.tk9-dogdad-bridge-header__time strong{font-size:10px}}"
    ].join("");
    (document.head || document.documentElement).appendChild(style);
  }

  function updateDogDadBridgeTimers(root) {
    var parts = countdownParts();
    (root || document).querySelectorAll("[data-tk9-dogdad-bridge-countdown]").forEach(function (node) {
      var days = node.querySelector("[data-tk9-bridge-days]");
      var hours = node.querySelector("[data-tk9-bridge-hours]");
      var minutes = node.querySelector("[data-tk9-bridge-minutes]");
      if (days) days.textContent = parts.days;
      if (hours) hours.textContent = parts.hours;
      if (minutes) minutes.textContent = parts.minutes;
    });
  }

  function dogDadTimerHtml(className) {
    return '<span class="' + className + '" data-tk9-dogdad-bridge-countdown>' +
      '<span>Ends in</span> ' +
      '<b data-tk9-bridge-days>--</b>D ' +
      '<b data-tk9-bridge-hours>--</b>H ' +
      '<b data-tk9-bridge-minutes>--</b>M' +
      '</span>';
  }

  function insertDogDadHeaderBridge() {
    if (document.querySelector(".tk9-dogdad-header,.tk9-dogdad-bridge-header")) return;
    if (/dogdad.*bundle offers|code dogdad|dog dad sale|use dogdad/i.test(document.body && document.body.innerText || "")) return;

    var headerGroup = document.getElementById("header-group");
    var navHeader = document.querySelector("[id*='header_section'], .header-section, header");
    var target = headerGroup || navHeader || document.body;
    if (!target || !target.parentNode) return;

    var section = document.createElement("section");
    section.className = "tk9-dogdad-bridge-header";
    section.setAttribute("aria-label", "Father's Day sale");
    section.innerHTML =
      '<a class="tk9-dogdad-bridge-header__inner" href="/discount/DOGDAD?redirect=%2Fcollections%2Fbest-sellers">' +
        '<span class="tk9-dogdad-bridge-header__proof" aria-label="9,465 Team K9 reviews"><span class="tk9-dogdad-bridge-header__stars" aria-hidden="true">★★★★★</span><span>9,465 reviews</span></span>' +
        '<span class="tk9-dogdad-bridge-header__label">Dog Dad Sale</span>' +
        '<span class="tk9-dogdad-bridge-header__offer"><span class="tk9-dogdad-bridge-header__offer-desktop">USE <strong>DOGDAD</strong> + BUNDLE OFFERS</span><span class="tk9-dogdad-bridge-header__offer-mobile">Use <strong>DOGDAD</strong> for extra cart savings</span></span>' +
        dogDadTimerHtml("tk9-dogdad-bridge-header__timer") +
        '<span class="tk9-dogdad-bridge-header__cta"><span class="tk9-dogdad-bridge-header__cta-desktop">Shop Sale</span><span class="tk9-dogdad-bridge-header__cta-mobile">Shop</span></span>' +
      '</a>';

    if (headerGroup) {
      headerGroup.insertBefore(section, headerGroup.firstChild);
    } else {
      target.parentNode.insertBefore(section, target);
    }
  }

  function hideStaleHomepageHero() {
    [
      "[id*='hero_section_legendary']",
      "[id*='product_hero_part1']",
      "[id*='product_hero_part']",
      ".hero-banner",
      ".hero"
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (node.closest(".tk9-dogdad-bridge-hero,.tk9-fd-hero")) return;
        node.classList.add("tk9-dogdad-bridge-hide");
      });
    });
  }

  function insertDogDadHeroBridge() {
    if (location.pathname !== "/" && location.pathname !== "") return;
    if (document.querySelector(".tk9-fd-hero,.tk9-dogdad-bridge-hero")) return;

    var main = document.getElementById("MainContent") || document.querySelector("main") || document.body;
    if (!main) return;

    var section = document.createElement("section");
    section.className = "tk9-dogdad-bridge-hero";
    section.setAttribute("aria-label", "Father's Day sale");
    section.innerHTML =
      '<div class="tk9-dogdad-bridge-hero__media" aria-hidden="true">' +
        '<img src="' + DOGDAD_HERO_IMAGE + '" alt="" loading="eager">' +
      '</div>' +
      '<div class="tk9-dogdad-bridge-hero__shade" aria-hidden="true"></div>' +
      '<div class="tk9-dogdad-bridge-hero__inner">' +
        '<div class="tk9-dogdad-bridge-hero__content">' +
          '<p class="tk9-dogdad-bridge-hero__eyebrow">Father&rsquo;s Day Weekend</p>' +
          '<h1>Dog Dad Sale</h1>' +
          '<p class="tk9-dogdad-bridge-hero__lead">Use DOGDAD at checkout and stack eligible bundle deals through Monday.</p>' +
          '<a class="tk9-dogdad-bridge-hero__cta" href="/discount/DOGDAD?redirect=%2Fcollections%2Fbest-sellers">Shop The Sale</a>' +
          '<div class="tk9-dogdad-bridge-hero__proof" aria-label="Team K9 shopping benefits">' +
            '<span><strong aria-hidden="true">★★★★★</strong> 9,465 reviews</span>' +
            '<span>Harnesses, car gear, pools, fans</span>' +
            '<span>Ends Monday</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    main.insertBefore(section, main.firstChild);
    hideStaleHomepageHero();
  }

  function insertDogDadCartTimerBridge() {
    if (document.querySelector("[data-tk9-cart-sale-timer],.tk9-dogdad-bridge-cart-timer")) return;
    var header = document.querySelector(".tk9-slide-cart__header");
    if (!header) return;
    var brand = header.querySelector(".tk9-slide-cart__brand") || header;
    var timer = document.createElement("div");
    timer.className = "tk9-slide-cart__sale-timer tk9-dogdad-bridge-cart-timer";
    timer.setAttribute("data-tk9-dogdad-bridge-countdown", "");
    timer.setAttribute("aria-label", "Father's Day sale countdown");
    timer.innerHTML = '<span>Sale ends</span><b data-tk9-bridge-days>--</b>D <b data-tk9-bridge-hours>--</b>H <b data-tk9-bridge-minutes>--</b>M';
    brand.appendChild(timer);
    updateDogDadBridgeTimers(timer);
  }

  function insertDogDadPdpOfferBridge() {
    if (location.pathname.indexOf("/products/") !== 0) return;
    var legacyOffer = document.querySelector(".tk9-dogdad-pdp-offer:not(.tk9-pdp-promo-strip)");
    if (!legacyOffer && document.querySelector(".tk9-pdp-promo-strip,[data-tk9-dogdad-pdp-offer-bridge],[data-tk9-fd-pdp-panel]")) {
      refreshDogDadPdpOfferCopy(document);
      return;
    }

    var trust = document.querySelector(".htusb-ui-prod-boost-under-form-wrapper");
    var buyButtons = document.querySelector(".buy-buttons-block, product-form-component, .product-form-buttons");
    var target = trust || buyButtons;
    if (!legacyOffer && (!target || !target.parentNode)) return;

    var offer = document.createElement("div");
    offer.className = "tk9-pdp-promo-strip tk9-dogdad-pdp-offer--bridge";
    offer.setAttribute("data-tk9-dogdad-pdp-offer-bridge", "");
    offer.setAttribute("data-tk9-fd-pdp-panel", "");
    offer.setAttribute("data-nosnippet", "");
    offer.setAttribute("aria-label", "Father's Day sale");
    var redirect = encodeURIComponent(location.pathname + location.search || "/collections/best-sellers");
    offer.innerHTML =
      '<span class="tk9-pdp-promo-strip__mark" aria-hidden="true"></span>' +
      '<div class="tk9-pdp-promo-strip__copy">' +
        '<span>Dog Dad Sale</span>' +
        '<strong>' + DOGDAD_PDP_OFFER_TEXT + '</strong>' +
      '</div>' +
      '<span class="tk9-pdp-promo-strip__ends">Ends Monday</span>' +
      '<a class="tk9-pdp-promo-strip__code" href="/discount/DOGDAD?redirect=' + redirect + '">Apply DOGDAD</a>';

    if (legacyOffer && legacyOffer.parentNode) {
      legacyOffer.parentNode.replaceChild(offer, legacyOffer);
    } else {
      target.parentNode.insertBefore(offer, target.nextSibling);
    }
  }

  function refreshDogDadPdpOfferCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(".tk9-pdp-promo-strip").forEach(function (offer) {
      var eyebrow = offer.querySelector(".tk9-pdp-promo-strip__copy span");
      var message = offer.querySelector(".tk9-pdp-promo-strip__copy strong");
      var cta = offer.querySelector(".tk9-pdp-promo-strip__code");
      if (eyebrow && eyebrow.textContent !== "Dog Dad Sale") eyebrow.textContent = "Dog Dad Sale";
      if (message && message.textContent !== DOGDAD_PDP_OFFER_TEXT) message.textContent = DOGDAD_PDP_OFFER_TEXT;
      if (cta && /apply\s+dogdad/i.test(cta.textContent || "")) {
        cta.setAttribute("data-tk9-apply-discount", "DOGDAD");
        cta.setAttribute("data-tk9-discount-source", cta.getAttribute("data-tk9-discount-source") || "pdp_promo_strip");
      }
    });
  }

  function initDogDadBridge() {
    if (!dogDadSaleActive()) return;
    injectDogDadBridgeCss();
    window.TeamK9SlideCartConfig = Object.assign({
      dogdadSaleEnabled: true,
      dogdadSaleCode: "DOGDAD",
      dogdadSaleLabel: "Dog Dad Sale",
      dogdadSaleEndsAt: DOGDAD_END_ISO
    }, window.TeamK9SlideCartConfig || {});

    function run() {
      insertDogDadHeaderBridge();
      insertDogDadHeroBridge();
      insertDogDadCartTimerBridge();
      insertDogDadPdpOfferBridge();
      refreshDogDadPdpOfferCopy(document);
      updateDogDadBridgeTimers(document);
    }

    run();
    window.setInterval(function () { updateDogDadBridgeTimers(document); }, 30000);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        insertDogDadCartTimerBridge();
        insertDogDadPdpOfferBridge();
        refreshDogDadPdpOfferCopy(document);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", run, { once: true });
    }
  }

  initDogDadBridge();

  function injectPdpPatchSizeOverrideCss() {
    if (document.getElementById("tk9-pdp-patch-size-override-css")) return;
    var style = document.createElement("style");
    style.id = "tk9-pdp-patch-size-override-css";
    style.textContent = [
      ".tk9-pdp-patch{--tk9-pdp-patch-preview-height:82px!important;--tk9-pdp-patch-preview-width:138px!important}",
      ".tk9-pdp-patch__card{grid-template-columns:18px 138px minmax(0,1fr)!important;min-height:104px!important}",
      ".tk9-pdp-patch__image-wrap{height:82px!important;max-width:138px!important;width:138px!important;padding:4px!important}",
      "@media(max-width:640px){.tk9-pdp-patch{--tk9-pdp-patch-preview-height:76px!important;--tk9-pdp-patch-preview-width:122px!important}.tk9-pdp-patch__card{grid-template-columns:18px 122px minmax(0,1fr)!important;min-height:96px!important}.tk9-pdp-patch__image-wrap{height:76px!important;max-width:122px!important;width:122px!important}}",
      "@media(max-width:380px){.tk9-pdp-patch{--tk9-pdp-patch-preview-height:70px!important;--tk9-pdp-patch-preview-width:108px!important}.tk9-pdp-patch__card{grid-template-columns:18px 108px minmax(0,1fr)!important}.tk9-pdp-patch__image-wrap{height:70px!important;max-width:108px!important;width:108px!important}}"
    ].join("");
    (document.head || document.documentElement).appendChild(style);
  }

  var dogDadApplyBusy = false;

  function dogDadApplyCtas() {
    return Array.prototype.slice.call(document.querySelectorAll(
      "[data-tk9-apply-discount], a[href*='/discount/DOGDAD'], a[href*='/discount/dogdad']"
    )).filter(function (node) {
      var text = String(node.textContent || "");
      return node.hasAttribute("data-tk9-apply-discount") || /apply\s+dogdad/i.test(text);
    });
  }

  function setDogDadApplyState(button, label, busy) {
    if (!button) return;
    if (!button.getAttribute("data-tk9-apply-discount-original")) {
      button.setAttribute("data-tk9-apply-discount-original", String(button.textContent || "").trim() || "Apply DOGDAD");
    }
    if (button.getAttribute("data-tk9-discount-display") === "footer") {
      if (/applying/i.test(label)) label = "Applying DOGDAD...";
      else if (/applied/i.test(label)) label = "DOGDAD applied";
      else label = "Apply DOGDAD";
    }
    button.textContent = label;
    button.classList.toggle("is-applied", !busy && /applied/i.test(label));
    button.setAttribute("aria-live", "polite");
    if (busy) button.setAttribute("aria-busy", "true");
    else button.removeAttribute("aria-busy");
  }

  function dogDadCartAttributes(cart) {
    var next = {};
    var attrs = cart && cart.attributes;
    if (attrs && typeof attrs === "object" && !Array.isArray(attrs)) {
      Object.keys(attrs).forEach(function (key) {
        if (attrs[key] != null) next[key] = attrs[key];
      });
    }
    next._tk9_discount_code = "DOGDAD";
    next.tk9_slide_cart_discount = "DOGDAD";
    return next;
  }

  function dogDadFetchJson(url, options) {
    return fetch(url, Object.assign({
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }, options || {})).then(function (response) {
      if (!response.ok) {
        var error = new Error("HTTP " + response.status);
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }

  function markDogDadApplied(cart) {
    try {
      window.sessionStorage.setItem("tk9_dogdad_discount_applied", "DOGDAD");
    } catch (error) {}
    dogDadApplyCtas().forEach(function (button) {
      setDogDadApplyState(button, "Applied", false);
    });
    patchDogDadCheckoutTargets(cart);
    document.documentElement.setAttribute("data-tk9-dogdad-apply-bridge", VERSION);
  }

  function dogDadCheckoutHref(rawHref) {
    var href = rawHref || "/checkout";
    try {
      var url = new URL(href, window.location.origin);
      if (url.pathname.indexOf("/checkout") !== 0) return href;
      if (!url.searchParams.get("discount")) url.searchParams.set("discount", "DOGDAD");
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return href.indexOf("?") === -1 ? href + "?discount=DOGDAD" : href + "&discount=DOGDAD";
    }
  }

  function dogDadDiscountIsReady(cart) {
    var attrs = cart && cart.attributes || {};
    if (/dogdad/i.test(String(attrs._tk9_discount_code || attrs.tk9_slide_cart_discount || ""))) return true;
    try {
      return window.sessionStorage.getItem("tk9_dogdad_discount_applied") === "DOGDAD";
    } catch (error) {
      return false;
    }
  }

  function patchDogDadCheckoutTargets(cart) {
    if (!dogDadDiscountIsReady(cart || state().cart || {})) return;
    document.querySelectorAll("[data-tk9-checkout], a[href*='/checkout']").forEach(function (node) {
      var href = node.getAttribute("href") || "/checkout";
      node.setAttribute("href", dogDadCheckoutHref(href));
      node.setAttribute("data-tk9-dogdad-checkout-discount", "DOGDAD");
    });
  }

  function applyDogDadFromBridge(button) {
    if (dogDadApplyBusy) return;
    dogDadApplyBusy = true;
    var fallbackUrl = button && button.getAttribute("href") || "";
    setDogDadApplyState(button, "Applying...", true);
    dogDadFetchJson("/cart.js?tk9_dogdad_apply=" + Date.now(), { method: "GET" })
      .catch(function () { return {}; })
      .then(function (cart) {
        return dogDadFetchJson("/cart/update.js", {
          method: "POST",
          body: JSON.stringify({
            discount: "DOGDAD",
            attributes: dogDadCartAttributes(cart)
          })
        });
      })
      .then(function (cart) {
        markDogDadApplied(cart);
        var slideCart = api();
        if (slideCart && typeof slideCart.refresh === "function") {
          return slideCart.refresh().catch(function () { return cart; });
        }
        return cart;
      })
      .catch(function () {
        var original = button && button.getAttribute("data-tk9-apply-discount-original");
        if (button && original) setDogDadApplyState(button, original, false);
        if (fallbackUrl) window.location.assign(fallbackUrl);
      })
      .finally(function () {
        dogDadApplyBusy = false;
      });
  }

  function bindDogDadPromoApplyBridge() {
    if (!dogDadSaleActive()) return;
    document.addEventListener("click", function (event) {
      var target = event.target && event.target.closest && event.target.closest(
        "[data-tk9-apply-discount], a[href*='/discount/DOGDAD'], a[href*='/discount/dogdad']"
      );
      if (!target) return;
      var hasApplyHook = target.hasAttribute("data-tk9-apply-discount");
      var text = String(target.textContent || "");
      if (!hasApplyHook && !/apply\s+dogdad/i.test(text)) return;
      var code = String(target.getAttribute("data-tk9-apply-discount") || "DOGDAD");
      if (!/dogdad/i.test(code)) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      applyDogDadFromBridge(target);
    }, true);
    document.addEventListener("click", function (event) {
      var checkout = event.target && event.target.closest && event.target.closest("[data-tk9-checkout], a[href*='/checkout']");
      if (checkout) patchDogDadCheckoutTargets();
    }, true);
    window.setInterval(function () { patchDogDadCheckoutTargets(); }, 1500);
  }

  bindDogDadPromoApplyBridge();

  function injectCartCloseCss() {
    if (document.getElementById("tk9-dogdad-cart-close-css")) return;
    var style = document.createElement("style");
    style.id = "tk9-dogdad-cart-close-css";
    style.textContent = [
      ".tk9-proof-chip{border-color:#f2c45d!important;background:linear-gradient(135deg,#fff8e7 0%,#fff 100%)!important;color:#173052!important;box-shadow:0 6px 14px rgba(214,145,23,.10)!important}",
      ".tk9-footer-row__label{color:#172033!important}",
      ".tk9-footer-code-pill{border-color:#61d48c!important;background:linear-gradient(135deg,#e9fff1 0%,#d4ffe3 100%)!important;color:#075c33!important;box-shadow:0 6px 14px rgba(10,143,83,.12)!important}",
      ".tk9-footer-code-pill--button{appearance:none!important;font-family:inherit!important;cursor:pointer!important}",
      ".tk9-footer-code-pill--button:focus-visible{outline:2px solid rgba(23,61,104,.35)!important;outline-offset:2px!important}",
      ".tk9-footer-code-pill--button[aria-busy='true']{cursor:wait!important;opacity:.72!important}",
      ".tk9-discount-message,.tk9-discount-toggle{color:#173d68!important}",
      ".tk9-installments,.tk9-trust-row{color:#45546a!important}"
    ].join("");
    (document.head || document.documentElement).appendChild(style);
  }

  function upgradeDogDadFooterPill(node, applied) {
    if (!node || !node.parentNode) return false;
    var label = applied ? "DOGDAD applied" : "Apply DOGDAD";
    if (
      node.tagName === "BUTTON" &&
      node.getAttribute("data-tk9-dogdad-close") === VERSION &&
      node.getAttribute("data-tk9-apply-discount") === "DOGDAD" &&
      String(node.textContent || "") === label
    ) return false;
    var button = node;
    if (node.tagName !== "BUTTON") {
      button = document.createElement("button");
      button.type = "button";
      button.className = node.className || "";
      node.parentNode.replaceChild(button, node);
    }
    button.classList.add("tk9-footer-code-pill");
    button.classList.add("tk9-footer-code-pill--button");
    button.textContent = label;
    button.setAttribute("data-tk9-apply-discount", "DOGDAD");
    button.setAttribute("data-tk9-discount-source", "cart_footer_promo");
    button.setAttribute("data-tk9-discount-display", "footer");
    button.setAttribute("data-tk9-dogdad-close", VERSION);
    return true;
  }

  function patchDogDadCartFooterCtas() {
    if (!dogDadSaleActive()) return false;
    injectCartCloseCss();
    var changed = false;
    document.querySelectorAll("[data-tk9-footer] .tk9-footer-code-pill, [data-tk9-footer] .tk9-footer-savings span").forEach(function (node) {
      var text = String(node.textContent || "");
      if (/dogdad|discount|sale savings/i.test(text)) {
        changed = upgradeDogDadFooterPill(node, /applied|savings/i.test(text)) || changed;
      }
    });
    return changed;
  }

  function injectSizeClarityCss() {
    if (document.getElementById("tk9-slide-cart-size-clarity-css")) return;
    var style = document.createElement("style");
    style.id = "tk9-slide-cart-size-clarity-css";
    style.textContent = [
      ".tk9-cart-line__selected{display:flex;flex-wrap:wrap;gap:6px;align-items:center;min-width:0;margin-top:4px;color:#667085;font-size:13px;font-weight:800;line-height:1.25;}",
      ".tk9-cart-line__selected-label{color:#59667a;font-weight:900;}",
      ".tk9-cart-line__setup{white-space:nowrap;}",
      ".tk9-cart-line__size-pill{display:inline-flex;align-items:baseline;gap:4px;padding:2px 8px;border-radius:999px;background:#f3f6fb;color:#111827;font-weight:950;white-space:nowrap;}",
      ".tk9-cart-line__size-pill em{font-style:normal;}",
      ".tk9-cart-line__size-pill small{color:#667085;font-size:11px;font-weight:900;}",
      ".tk9-cart-line__size-note{margin-top:3px;color:#667085;font-size:11.5px;font-weight:800;line-height:1.2;}",
      ".tk9-cart-line__size-note-compact{display:none;}",
      "@media(max-width:520px){.tk9-cart-line__selected{gap:3px;font-size:11px;line-height:1.12}.tk9-cart-line__selected-label{display:none}.tk9-cart-line__size-pill{gap:2px;padding:2px 6px}.tk9-cart-line__size-pill span{display:none}.tk9-cart-line__size-pill em{font-size:11px}.tk9-cart-line__size-pill small{font-size:9.5px}.tk9-cart-line__size-note{max-width:100%;margin-top:2px;font-size:8.8px;line-height:1;white-space:nowrap}.tk9-cart-line__size-note-full{display:none}.tk9-cart-line__size-note-compact{display:inline}}"
    ].join("");
    (document.head || document.documentElement).appendChild(style);
  }

  function api() {
    return window.TeamK9SlideCart && typeof window.TeamK9SlideCart.getState === "function"
      ? window.TeamK9SlideCart
      : null;
  }

  function state() {
    var slideCart = api();
    return slideCart ? slideCart.getState() || {} : {};
  }

  function cartItems() {
    var current = state();
    return current.cart && Array.isArray(current.cart.items) ? current.cart.items : [];
  }

  function rules() {
    return state().rules || {};
  }

  function normalizeText(value) {
    return String(value || "").toLowerCase().replace(/\s+/g, " ").trim();
  }

  function money(cents) {
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function roundedDollarAmount(cents) {
    var amount = Number(cents || 0);
    if (!isFinite(amount) || amount <= 0) return "";
    return "$" + Math.max(1, Math.round(amount / 100));
  }

  function roundedSavingsText(compareAtCents, priceCents) {
    var rounded = roundedDollarAmount(Number(compareAtCents || 0) - Number(priceCents || 0));
    return rounded ? rounded + " OFF" : "";
  }

  function formattedWholeDollars(cents) {
    return "$" + Math.ceil(Number(cents || 0) / 100);
  }

  function kitSavingsCue(currentCents, nextCents) {
    var current = Math.max(0, Number(currentCents || 0));
    var next = Math.max(0, Number(nextCents || 0));
    var incremental = Math.max(next - current, 0);
    if (!incremental) return "";
    return current
      ? "Cart savings increase by " + formattedWholeDollars(incremental)
      : "Cart savings increase by " + formattedWholeDollars(next);
  }

  function previewKitDiscountCents(lineDiscountCents, currentKitSavingsCents, nextKitSavingsCents, compareAtCents) {
    var compareAt = Math.max(0, Number(compareAtCents || 0));
    var current = Math.max(0, Number(currentKitSavingsCents || 0));
    var next = Math.max(0, Number(nextKitSavingsCents || 0));
    var incremental = Math.max(next - current, 0);
    var discount = incremental || Math.max(0, Number(lineDiscountCents || 0));
    return compareAt ? Math.min(discount, compareAt) : discount;
  }

  function priceHtml(priceCents, compareAtCents) {
    var price = Number(priceCents || 0);
    var compareAt = Number(compareAtCents || 0);
    if (compareAt > price) {
      return '<span class="tk9-discount-price"><s>' + money(compareAt) + "</s> " + money(price) + "</span>";
    }
    return money(price);
  }

  function lineQuantity(line) {
    return Math.max(1, Number(line && line.quantity || 1));
  }

  function triggerLinesForGroup(group) {
    var triggers = (group && group.triggerProductIds || []).map(Number);
    if (!triggers.length) return [];
    return cartItems().filter(function (line) {
      return triggers.indexOf(Number(line && line.product_id)) !== -1;
    });
  }

  function triggerUnitsForGroup(group) {
    var units = [];
    triggerLinesForGroup(group).forEach(function (line) {
      var quantity = Math.min(lineQuantity(line), 12);
      for (var index = 0; index < quantity; index += 1) units.push(line);
    });
    return units;
  }

  function cartLineText(line) {
    return normalizeText([
      line && line.title,
      line && line.product_title,
      line && line.variant_title,
      line && line.sku,
      line && line.options_with_values && JSON.stringify(line.options_with_values),
      line && line.properties && JSON.stringify(line.properties)
    ].join(" "));
  }

  function detectColor(line) {
    var text = cartLineText(line);
    if (/pink camo/.test(text)) return "pink-camo";
    if (/multi cam|multicam|camouflage/.test(text)) return "multicam";
    if (/lavender|purple/.test(text)) return "lavender";
    if (/orange|blaze/.test(text)) return "orange";
    if (/black|k9 black/.test(text)) return "black";
    if (/brown|desert/.test(text)) return "brown";
    if (/green|olive/.test(text)) return "green";
    if (/gray|grey/.test(text)) return "gray";
    if (/beige|tan/.test(text)) return "beige";
    return "default";
  }

  function detectSize(line) {
    var text = cartLineText(line);
    if (/extra large|extra-large|x-large|xl|bigger truck|bigger trucks|fits bigger/.test(text)) return "extra-large";
    if (/extra small|extra-small|xs/.test(text)) return "extra-small";
    if (/large/.test(text)) return "large";
    if (/medium/.test(text)) return "medium";
    if (/small/.test(text)) return "small";
    return "default";
  }

  function contextFromLine(line) {
    return {
      color: detectColor(line),
      size: detectSize(line),
      triggerLine: line
    };
  }

  function componentUnique(ids) {
    var seen = {};
    var result = [];
    (ids || []).forEach(function (id) {
      if (!id || seen[id]) return;
      seen[id] = true;
      result.push(id);
    });
    return result;
  }

  function componentSubsets(items) {
    var list = componentUnique(items);
    var result = [];
    for (var mask = 1; mask < Math.pow(2, list.length); mask += 1) {
      var selected = [];
      for (var index = 0; index < list.length; index += 1) {
        if (mask & (1 << index)) selected.push(list[index]);
      }
      result.push(selected);
    }
    return result;
  }

  function componentKey(ids) {
    return componentUnique(ids).sort().join("|");
  }

  function componentSubset(needed, available) {
    var availableMap = {};
    (available || []).forEach(function (id) {
      availableMap[id] = true;
    });
    return (needed || []).every(function (id) {
      return availableMap[id];
    });
  }

  function productIds() {
    return rules().productIds || {};
  }

  function kitComponentProductIds(kind) {
    var ids = productIds();
    if (kind === "cover") {
      return {
        bed: [ids.backseatDogBed || 7586514567267],
        fans: [ids.dualHeadrestCoolingFans || 7827615121507],
        "single-seat-cover": [ids.singleSeatCover || 6845717872739],
        "cargo-cover": [ids.cargoCover || 6845717905507],
        "throw-blanket": [ids.throwBlanket || 7994154942563],
        "safety-belt": [ids.carSafetyBelt || 6762308337763],
        "travel-bowl": [ids.travelBowl || 6784072122467],
        "hair-removal-gloves": [ids.hairRemovalGloves || 7892526432355]
      };
    }
    if (kind === "pool") {
      return {
        "pool-cover": [ids.dogPoolCover || 6920870527075],
        "splash-pad": [ids.splashPad || 7383496261731],
        "paw-drying-mat": [ids.floorMat || 6735967256675],
        "quick-dry-towel": [ids.quickDryTowel || 7775269453923],
        "pool-travel-bowl": [ids.travelBowl || 6784072122467],
        "pool-hair-removal-gloves": [ids.hairRemovalGloves || 7892526432355]
      };
    }
    return {
      leash: [ids.tacticalLeash || 4508637560931],
      collar: [ids.tacticalCollar || 4508633759843],
      "patch-bundle": [ids.patchBundle || 6840101797987],
      "molle-pouch": [ids.tacticalPouch || 6744451809379],
      "custom-patch": [ids.customPatch || 4734560632931],
      "dog-goggles": [ids.dogGoggles || 6905734070371],
      "first-aid-kit": [ids.firstAidKit || 6884659200099],
      "safety-belt": [ids.carSafetyBelt || 6762308337763]
    };
  }

  function kitOfferComponent(kind, offerId) {
    var cover = {
      "backseat-bed": "bed",
      "dual-fans": "fans",
      "single-seat-cover": "single-seat-cover",
      "cargo-cover": "cargo-cover",
      "throw-blanket": "throw-blanket",
      "extra-safety-belt": "safety-belt",
      "travel-bowl": "travel-bowl",
      "hair-removal-gloves": "hair-removal-gloves"
    };
    var harness = {
      "matched-leash": "leash",
      "matched-collar": "collar",
      "patch-variety": "patch-bundle",
      "molle-pouch": "molle-pouch",
      "custom-patch": "custom-patch",
      "dog-goggles": "dog-goggles",
      "first-aid-kit": "first-aid-kit",
      "harness-safety-belt": "safety-belt"
    };
    var pool = {
      "pool-cover": "pool-cover",
      "splash-pad": "splash-pad",
      "paw-drying-mat": "paw-drying-mat",
      "quick-dry-towel": "quick-dry-towel",
      "pool-travel-bowl": "pool-travel-bowl",
      "pool-hair-removal-gloves": "pool-hair-removal-gloves"
    };
    return (kind === "cover" ? cover : kind === "pool" ? pool : harness)[offerId] || "";
  }

  function triggerProductIdMap(group) {
    var map = {};
    (group && group.triggerProductIds || []).forEach(function (id) {
      map[Number(id)] = true;
    });
    return map;
  }

  function lineMatchesKitContext(kind, componentId, triggerContext, line) {
    if (!triggerContext || !line) return true;
    var context = contextFromLine(line);
    if (kind === "cover" && componentId === "bed") {
      if (triggerContext.size && context.size && triggerContext.size !== context.size) return false;
      if (triggerContext.color && context.color && triggerContext.color !== context.color) return false;
    }
    if (kind === "pool" && componentId === "pool-cover") {
      if (triggerContext.size && context.size && triggerContext.size !== context.size) return false;
    }
    return true;
  }

  function componentsInCartForKit(kind, group, triggerContext) {
    var productMap = kitComponentProductIds(kind);
    var triggerMap = triggerProductIdMap(group);
    var found = [];
    cartItems().forEach(function (line) {
      var productId = Number(line && line.product_id);
      if (!productId || triggerMap[productId]) return;
      Object.keys(productMap).forEach(function (componentId) {
        if (productMap[componentId].map(Number).indexOf(productId) === -1) return;
        if (!lineMatchesKitContext(kind, componentId, triggerContext, line)) return;
        found.push(componentId);
      });
    });
    return componentUnique(found);
  }

  function coverBaseComponentsFromTriggerLines(lines) {
    var found = [];
    (lines || []).forEach(function (line) {
      if (/plush backseat dog bed|backseat dog bed|seat cover bed|cover bed|dog bed bundle/.test(cartLineText(line))) {
        found.push("bed");
      }
    });
    return componentUnique(found);
  }

  function poolBaseComponentsFromTriggerLines(lines) {
    var patterns = [
      { id: "pool-cover", pattern: /\b(waterproof\s*cover|pool\s*cover|dog\s*pool\s*cover)\b/ },
      { id: "splash-pad", pattern: /\b(splash\s*pad|fountain)\b/ },
      { id: "paw-drying-mat", pattern: /\b(paw[-\s]*drying|floor\s*mat|drying\s*mat)\b/ },
      { id: "quick-dry-towel", pattern: /\b(quick[-\s]*dry|dog\s*towel|towel)\b/ },
      { id: "pool-travel-bowl", pattern: /\b(travel\s*bowl|water\s*bowl|collapsible\s*bowl)\b/ }
    ];
    var found = [];
    (lines || []).forEach(function (line) {
      var text = cartLineText(line);
      patterns.forEach(function (item) {
        if (item.pattern.test(text)) found.push(item.id);
      });
    });
    return componentUnique(found);
  }

  function harnessMappedBaseComponents(line) {
    var map = offerEnginePricing("harness").variantBaseComponents || {};
    var variantId = String(line && (line.variant_id || line.id || line.variantId) || "");
    var components = map[variantId];
    return Array.isArray(components) ? components.slice() : [];
  }

  function harnessBaseComponentsFromTriggerLines(lines) {
    var patterns = [
      { id: "leash", pattern: /\b(leash|bungee)\b/ },
      { id: "collar", pattern: /\bcollar\b/ },
      { id: "patch-bundle", pattern: /\b(12\s*patch|12\s*patches|patch\s*bundle)\b/ },
      { id: "molle-pouch", pattern: /\b(molle|pouch)\b/ },
      { id: "custom-patch", pattern: /\b(custom\s*patch|personalized\s*patch|name\s*patch)\b/ },
      { id: "dog-goggles", pattern: /\b(doggles|dog\s*goggles|goggles)\b/ },
      { id: "first-aid-kit", pattern: /\b(first\s*aid)\b/ },
      { id: "safety-belt", pattern: /\b(safety\s*belt)\b/ }
    ];
    var found = [];
    (lines || []).forEach(function (line) {
      var mapped = harnessMappedBaseComponents(line);
      if (mapped.length) {
        found = found.concat(mapped);
        return;
      }
      var text = cartLineText(line);
      patterns.forEach(function (item) {
        if (item.pattern.test(text)) found.push(item.id);
      });
    });
    return componentUnique(found);
  }

  function offerEnginePricing(kind) {
    var current = state();
    return current.offerEngine && current.offerEngine.pricing && current.offerEngine.pricing[kind] || {};
  }

  function engineCents(kind, mapName, key) {
    var map = offerEnginePricing(kind)[mapName] || {};
    return Number(map[String(key)] || 0);
  }

  function fallbackCoverBundleDiscounts() {
    return {
      bed: 2000,
      fans: 1000,
      "single-seat-cover": 1000,
      "cargo-cover": 1000,
      "bed|fans": 3500,
      "bed|single-seat-cover": 3500,
      "bed|cargo-cover": 3500,
      "fans|single-seat-cover": 2500,
      "cargo-cover|fans": 2500,
      "cargo-cover|single-seat-cover": 2500,
      "bed|fans|single-seat-cover": 5500,
      "bed|cargo-cover|fans": 5500,
      "bed|cargo-cover|single-seat-cover": 5500,
      "bed|cargo-cover|fans|single-seat-cover": 7000
    };
  }

  function fallbackComponentMap(kind, mapName) {
    var maps = {
      cover: {
        fallback: {
          bed: 2000,
          fans: 1000,
          "single-seat-cover": 1000,
          "cargo-cover": 1000,
          "throw-blanket": 500,
          "safety-belt": 500,
          "travel-bowl": 500
        },
        standalone: {
          bed: 8999,
          fans: 5999,
          "single-seat-cover": 4999,
          "cargo-cover": 7999,
          "throw-blanket": 3499,
          "safety-belt": 2499,
          "travel-bowl": 2499
        }
      },
      pool: {
        fallback: {
          "pool-cover": 1000,
          "splash-pad": 1000,
          "paw-drying-mat": 500,
          "quick-dry-towel": 500,
          "pool-travel-bowl": 500
        },
        standalone: {
          "pool-cover": 3499,
          "splash-pad": 7999,
          "paw-drying-mat": 3999,
          "quick-dry-towel": 3499,
          "pool-travel-bowl": 2499
        }
      },
      harness: {
        fallback: {
          leash: 500,
          collar: 500,
          "patch-bundle": 500,
          "molle-pouch": 500,
          "custom-patch": 500,
          "dog-goggles": 500,
          "first-aid-kit": 500,
          "safety-belt": 500
        },
        standalone: {
          leash: 4499,
          collar: 4499,
          "patch-bundle": 3999,
          "molle-pouch": 4499,
          "custom-patch": 2999,
          "dog-goggles": 4999,
          "first-aid-kit": 3499,
          "safety-belt": 2499
        }
      }
    };
    return maps[kind] && maps[kind][mapName] || {};
  }

  function componentMapCents(kind, mapName, componentId) {
    var runtimeMapName = mapName === "standalone" ? "componentStandaloneCents" : "componentFallbackDiscountCents";
    return engineCents(kind, runtimeMapName, componentId) || Number(fallbackComponentMap(kind, mapName)[componentId] || 0);
  }

  function coverBundleDiscountCents(components) {
    var key = componentKey(components);
    return engineCents("cover", "bundleDiscountCents", key) || Number(fallbackCoverBundleDiscounts()[key] || 0);
  }

  function coverBundleKeys() {
    var runtime = offerEnginePricing("cover").bundleDiscountCents || {};
    var keys = Object.keys(runtime);
    return keys.length ? keys : Object.keys(fallbackCoverBundleDiscounts());
  }

  function fallbackPoolBundleDiscounts() {
    var components = ["pool-cover", "splash-pad", "paw-drying-mat", "quick-dry-towel", "pool-travel-bowl"];
    var primary = { "pool-cover": true, "splash-pad": true };
    var result = {};
    componentSubsets(components).forEach(function (selected) {
      var primaryCount = selected.filter(function (id) { return primary[id]; }).length;
      var secondaryCount = selected.length - primaryCount;
      result[componentKey(selected)] = (primaryCount * 1000) + (secondaryCount * 500) + (Math.max(selected.length - 1, 0) * 500);
    });
    return result;
  }

  function poolBundleDiscountCents(components) {
    var key = componentKey(components);
    return engineCents("pool", "bundleDiscountCents", key) || Number(fallbackPoolBundleDiscounts()[key] || 0);
  }

  function poolBundleKeys() {
    var runtime = offerEnginePricing("pool").bundleDiscountCents || {};
    var keys = Object.keys(runtime);
    return keys.length ? keys : Object.keys(fallbackPoolBundleDiscounts());
  }

  function allocatedKitPlan(totalCents, componentIds, fallbackForComponent, maxForComponent) {
    var remaining = Math.max(0, Number(totalCents || 0));
    var allocations = {};
    (componentIds || []).forEach(function (componentId) {
      var max = Math.max(0, Number(maxForComponent(componentId) || 0));
      var amount = Math.min(remaining, Math.max(0, Number(fallbackForComponent(componentId) || 0)), max || remaining);
      allocations[componentId] = (allocations[componentId] || 0) + amount;
      remaining -= amount;
    });
    for (var index = (componentIds || []).length - 1; index >= 0 && remaining > 0; index -= 1) {
      var id = componentIds[index];
      var maxCents = Math.max(0, Number(maxForComponent(id) || 0));
      var capacity = maxCents ? Math.max(maxCents - Number(allocations[id] || 0), 0) : remaining;
      var extra = Math.min(remaining, capacity);
      allocations[id] = (allocations[id] || 0) + extra;
      remaining -= extra;
    }
    return {
      allocatedCents: Object.keys(allocations).reduce(function (sum, id) {
        return sum + Number(allocations[id] || 0);
      }, 0),
      allocations: allocations
    };
  }

  function bestCoverKitPlan(baseComponents, availableComponents) {
    var base = componentUnique(baseComponents);
    var available = componentUnique(availableComponents).filter(function (id) {
      return base.indexOf(id) === -1;
    });
    var baseDiscount = coverBundleDiscountCents(base);
    var comboKeys = coverBundleKeys();
    var best = null;
    componentSubsets(available).forEach(function (selected) {
      var combined = base.concat(selected);
      var exactKey = componentKey(combined);
      var candidateKeys = comboKeys.indexOf(exactKey) !== -1 ? [exactKey] : comboKeys.filter(function (key) {
        var comboComponents = key ? key.split("|") : [];
        return componentSubset(base, comboComponents) && componentSubset(comboComponents, combined);
      }).concat("");
      componentUnique(candidateKeys).forEach(function (comboKey) {
        var comboComponents = comboKey ? comboKey.split("|") : [];
        var comboAdded = selected.filter(function (id) {
          return comboComponents.indexOf(id) !== -1;
        });
        var fallbackComponents = selected.filter(function (id) {
          return comboComponents.indexOf(id) === -1;
        });
        var discount = comboKey && comboAdded.length ? Math.max(0, coverBundleDiscountCents(comboComponents) - baseDiscount) : 0;
        fallbackComponents.forEach(function (id) {
          discount += componentMapCents("cover", "fallback", id);
        });
        if (!discount) return;
        if (!best || discount > best.discountCents || (discount === best.discountCents && selected.length > best.componentIds.length)) {
          best = { discountCents: discount, componentIds: selected };
        }
      });
    });
    if (!best) return { discountCents: 0, allocatedCents: 0, allocations: {}, componentIds: [] };
    return Object.assign({}, best, allocatedKitPlan(
      best.discountCents,
      best.componentIds,
      function (id) { return componentMapCents("cover", "fallback", id); },
      function (id) { return componentMapCents("cover", "standalone", id); }
    ));
  }

  function bestPoolKitPlan(baseComponents, availableComponents) {
    var base = componentUnique(baseComponents);
    var available = componentUnique(availableComponents).filter(function (id) {
      return base.indexOf(id) === -1;
    });
    var baseDiscount = poolBundleDiscountCents(base);
    var comboKeys = poolBundleKeys();
    var best = null;
    componentSubsets(available).forEach(function (selected) {
      var combined = base.concat(selected);
      var exactKey = componentKey(combined);
      var candidateKeys = comboKeys.indexOf(exactKey) !== -1 ? [exactKey] : comboKeys.filter(function (key) {
        var comboComponents = key ? key.split("|") : [];
        return componentSubset(base, comboComponents) && componentSubset(comboComponents, combined);
      }).concat("");
      componentUnique(candidateKeys).forEach(function (comboKey) {
        var comboComponents = comboKey ? comboKey.split("|") : [];
        var comboAdded = selected.filter(function (id) {
          return comboComponents.indexOf(id) !== -1;
        });
        var fallbackComponents = selected.filter(function (id) {
          return comboComponents.indexOf(id) === -1;
        });
        var discount = comboKey && comboAdded.length ? Math.max(0, poolBundleDiscountCents(comboComponents) - baseDiscount) : 0;
        fallbackComponents.forEach(function (id) {
          discount += componentMapCents("pool", "fallback", id);
        });
        if (!discount) return;
        if (!best || discount > best.discountCents || (discount === best.discountCents && selected.length > best.componentIds.length)) {
          best = { discountCents: discount, componentIds: selected };
        }
      });
    });
    if (!best) return { discountCents: 0, allocatedCents: 0, allocations: {}, componentIds: [] };
    return Object.assign({}, best, allocatedKitPlan(
      best.discountCents,
      best.componentIds,
      function (id) { return componentMapCents("pool", "fallback", id); },
      function (id) { return componentMapCents("pool", "standalone", id); }
    ));
  }

  function harnessLadderDiscountCents(count) {
    var ladder = offerEnginePricing("harness").accessoryLadderCents || {
      1: 500,
      2: 1500,
      3: 3000,
      4: 5000,
      5: 7500,
      6: 10500,
      7: 14000,
      8: 18000
    };
    var best = 0;
    Object.keys(ladder).forEach(function (key) {
      if (Number(key) <= Number(count || 0)) best = Math.max(best, Number(ladder[key] || 0));
    });
    return best;
  }

  function harnessPrebuiltComponentIncrementalCapsCents() {
    return offerEnginePricing("harness").prebuiltComponentIncrementalDiscountCapsCents || {};
  }

  function bestHarnessKitPlan(baseComponents, availableComponents) {
    var order = ["leash", "collar", "patch-bundle", "molle-pouch", "custom-patch", "dog-goggles", "first-aid-kit", "safety-belt"];
    var base = componentUnique(baseComponents);
    var openSlots = Math.max(8 - base.length, 0);
    var available = order.filter(function (id) {
      return base.indexOf(id) === -1 && componentUnique(availableComponents).indexOf(id) !== -1;
    }).slice(0, openSlots);
    var caps = base.length ? harnessPrebuiltComponentIncrementalCapsCents() : {};
    var runningCount = base.length;
    var discount = available.reduce(function (sum, componentId) {
      var before = harnessLadderDiscountCents(runningCount);
      var after = harnessLadderDiscountCents(runningCount + 1);
      runningCount += 1;
      var incrementalDiscount = Math.max(after - before, 0);
      var cap = Number(caps[componentId]);
      return sum + (Number.isFinite(cap) && cap >= 0 ? Math.min(incrementalDiscount, cap) : incrementalDiscount);
    }, 0);
    if (!discount || !available.length) return { discountCents: 0, allocatedCents: 0, allocations: {}, componentIds: [] };
    return Object.assign({
      discountCents: discount,
      componentIds: available
    }, allocatedKitPlan(
      discount,
      available,
      function (id) { return componentMapCents("harness", "fallback", id) || 500; },
      function (id) { return componentMapCents("harness", "standalone", id); }
    ));
  }

  function groupKind(group) {
    if (!group) return "";
    if (group.id === "seat-cover-setup") return "cover";
    if (group.id === "pool-setup") return "pool";
    if (group.id === "harness-setup") return "harness";
    return "";
  }

  function offerGroups() {
    return Array.isArray(rules().offerGroups) ? rules().offerGroups : [];
  }

  function findGroup(node) {
    var groupId = node.getAttribute("data-tk9-offer-group");
    var groups = offerGroups();
    if (groupId) {
      return groups.find(function (group) {
        return group.id === groupId;
      }) || null;
    }
    var offerId = node.getAttribute("data-tk9-offer");
    return groups.find(function (group) {
      return groupKind(group) && (group.offers || []).some(function (offer) {
        return offer.id === offerId;
      });
    }) || null;
  }

  function findRawOffer(group, offerId) {
    return group && (group.offers || []).find(function (offer) {
      return offer.id === offerId;
    }) || null;
  }

  function resolveCompareAtCents(offer, variantId, kind, componentId, node) {
    var map = offer && (offer.compareAtVariantMap || offer.standalonePriceVariantMap) || {};
    var keyed = map[String(variantId)];
    return Number(
      keyed ||
      offer && (offer.standalonePriceCents || offer.compareAtPriceCents) ||
      componentMapCents(kind, "standalone", componentId) ||
      node.getAttribute("data-tk9-offer-standalone-price-cents") ||
      node.getAttribute("data-tk9-offer-price-cents") ||
      0
    );
  }

  function patchSelectOptions(node, lineDiscount, fallbackCompareAt) {
    var select = node.querySelector("[data-tk9-offer-variant]");
    if (!select) return { priceCents: 0, compareAtCents: 0 };
    Array.prototype.forEach.call(select.options || [], function (option) {
      var compareAt = Number(option.getAttribute("data-standalone-price-cents") || fallbackCompareAt || 0);
      if (!compareAt) return;
      option.setAttribute("data-standalone-price-cents", String(compareAt));
      option.setAttribute("data-price-cents", String(Math.max(compareAt - lineDiscount, 0)));
    });
    var selected = select.options && select.options[select.selectedIndex];
    return {
      priceCents: selected ? Number(selected.getAttribute("data-price-cents") || 0) : 0,
      compareAtCents: selected ? Number(selected.getAttribute("data-standalone-price-cents") || 0) : 0
    };
  }

  function patchOfferNode(node) {
    var offerId = node.getAttribute("data-tk9-offer");
    var group = findGroup(node);
    var kind = groupKind(group);
    if (!kind || !offerId) return false;

    var componentId = kitOfferComponent(kind, offerId);
    var offer = findRawOffer(group, offerId);
    if (!componentId || !offer || offer.action === "change_variant") return false;

    var triggerLines = triggerUnitsForGroup(group);
    var triggerContext = triggerLines.length ? contextFromLine(triggerLines[0]) : null;
    var baseComponents = kind === "cover"
      ? coverBaseComponentsFromTriggerLines(triggerLines)
      : kind === "pool"
        ? poolBaseComponentsFromTriggerLines(triggerLines)
        : harnessBaseComponentsFromTriggerLines(triggerLines);
    var currentComponents = componentsInCartForKit(kind, group, triggerContext);
    if (baseComponents.indexOf(componentId) !== -1 || currentComponents.indexOf(componentId) !== -1) return false;

    var currentPlan = kind === "cover"
      ? bestCoverKitPlan(baseComponents, currentComponents)
      : kind === "pool"
        ? bestPoolKitPlan(baseComponents, currentComponents)
        : bestHarnessKitPlan(baseComponents, currentComponents);
    var nextComponents = currentComponents.concat(componentId);
    var nextPlan = kind === "cover"
      ? bestCoverKitPlan(baseComponents, nextComponents)
      : kind === "pool"
        ? bestPoolKitPlan(baseComponents, nextComponents)
        : bestHarnessKitPlan(baseComponents, nextComponents);
    var baseSavings = kind === "cover"
      ? coverBundleDiscountCents(baseComponents)
      : kind === "pool"
        ? poolBundleDiscountCents(baseComponents)
        : harnessLadderDiscountCents(baseComponents.length);
    var currentTotal = baseSavings + Number(currentPlan.allocatedCents || 0);
    var nextTotal = baseSavings + Number(nextPlan.allocatedCents || 0);
    if (nextTotal <= currentTotal) return false;

    var variantId = Number(node.getAttribute("data-tk9-offer-variant-id") || offer.variantId || offer.targetVariantId || offer.fallbackVariantId || 0);
    var compareAt = resolveCompareAtCents(offer, variantId, kind, componentId, node);
    var lineDiscount = previewKitDiscountCents(
      Number(nextPlan.allocations && nextPlan.allocations[componentId] || 0),
      currentTotal,
      nextTotal,
      compareAt
    );
    if (!lineDiscount || !compareAt) return false;

    var selected = patchSelectOptions(node, lineDiscount, compareAt);
    var price = selected.priceCents || Math.max(compareAt - lineDiscount, 0);
    var selectedCompareAt = selected.compareAtCents || compareAt;
    node.setAttribute("data-tk9-offer-price-cents", String(price));
    node.setAttribute("data-tk9-offer-standalone-price-cents", String(selectedCompareAt));
    node.setAttribute("data-tk9-stale-guard", VERSION);

    var priceNode = node.querySelector("[data-tk9-offer-price]");
    if (priceNode) priceNode.innerHTML = priceHtml(price, selectedCompareAt);

    var cueNode = Array.prototype.find.call(node.querySelectorAll(".tk9-offer__cue"), function (candidate) {
      return !candidate.hasAttribute("data-tk9-offer-savings") && !candidate.classList.contains("tk9-offer__cue--savings");
    });
    if (cueNode && cueNode.parentNode) cueNode.parentNode.removeChild(cueNode);

    var savingsText = roundedSavingsText(selectedCompareAt, price);
    if (savingsText) {
      var actions = node.querySelector(".tk9-offer__price-wrap") || node.querySelector(".tk9-offer__actions");
      var savingsNode = node.querySelector("[data-tk9-offer-savings]");
      if (!savingsNode && actions) {
        savingsNode = document.createElement("span");
        savingsNode.className = "tk9-offer__cue tk9-offer__cue--savings";
        savingsNode.setAttribute("data-tk9-offer-savings", "");
        actions.appendChild(savingsNode);
      }
      if (savingsNode) {
        savingsNode.textContent = savingsText;
        savingsNode.hidden = false;
      }
    }
    return true;
  }

  function protectionProductIds() {
    var ids = productIds();
    var fromRules = (rules().protection || []).map(function (item) {
      return Number(item && item.productId);
    }).filter(Boolean);
    return componentUnique(fromRules.concat([
      Number(ids.shippingInsurance || 7831307681891),
      Number(ids.lifetimeWarranty || 7823183151203)
    ]).map(String)).map(Number);
  }

  function protectionTotalCents() {
    var protectionIds = protectionProductIds();
    return cartItems().reduce(function (sum, line) {
      return protectionIds.indexOf(Number(line && line.product_id)) === -1
        ? sum
        : sum + Number(line.final_line_price || line.line_price || line.price || 0);
    }, 0);
  }

  function parseMoneyText(text) {
    var matches = String(text || "").match(/\$[\d,]+(?:\.\d{2})?/g) || [];
    if (!matches.length) return [];
    return matches.map(function (value) {
      return Math.round(Number(value.replace(/[$,]/g, "")) * 100);
    });
  }

  function hasCartLevelDiscount() {
    var cart = state().cart || {};
    return Array.isArray(cart.discount_applications) && cart.discount_applications.length > 0;
  }

  function patchFooterProtectionTotal() {
    var protectionTotal = protectionTotalCents();
    if (!protectionTotal || hasCartLevelDiscount()) return false;
    var footerValue = document.querySelector("[data-tk9-footer] .tk9-footer-row__value");
    if (!footerValue) return false;
    var totals = parseMoneyText(footerValue.textContent);
    if (!totals.length) return false;
    var currentTotal = totals[totals.length - 1];
    var rawTotal = Number(state().cart && state().cart.total_price || 0);
    if (!rawTotal || Math.abs((currentTotal + protectionTotal) - rawTotal) > 3 || Math.abs(currentTotal - rawTotal) <= 3) {
      return false;
    }
    var compareAt = totals.length > 1 ? totals[0] : 0;
    var nextTotal = currentTotal + protectionTotal;
    var nextCompareAt = compareAt ? compareAt + protectionTotal : 0;
    footerValue.innerHTML = nextCompareAt > nextTotal
      ? '<span><s>' + money(nextCompareAt) + "</s> " + money(nextTotal) + "</span>"
      : money(nextTotal);

    var installment = document.querySelector("[data-tk9-footer] .tk9-installments");
    if (installment && nextTotal >= 5000) {
      installment.innerHTML = "Or 4 interest-free payments of " + money(Math.ceil(nextTotal / 4)) + " with <strong>shop<span>Pay</span></strong>";
    }
    footerValue.setAttribute("data-tk9-stale-guard", VERSION);
    return true;
  }

  function repair() {
    var current = state();
    var changed = patchDogDadCartFooterCtas();
    if (!current.rules || !current.cart) return;
    document.querySelectorAll("[data-tk9-offer]").forEach(function (node) {
      if (patchOfferNode(node)) changed = true;
    });
    if (patchFooterProtectionTotal()) changed = true;
    if (changed) document.documentElement.setAttribute("data-tk9-stale-guard", VERSION);
  }

  function loadCurrentSlideCartRuntime() {
    if (window.__tk9SlideCartAssetVersion === CURRENT_SLIDE_CART_VERSION) return;
    if (document.querySelector("script[data-tk9-slide-cart-processing-cutoff-fallback]")) return;

    var currentScript = document.currentScript;
    var guardScript = currentScript && /tk9-slide-cart-stale-guard\.js/i.test(currentScript.src || "")
      ? currentScript
      : document.querySelector('script[src*="tk9-slide-cart-stale-guard.js"]');
    var source = guardScript && guardScript.src ? guardScript.src : "";
    var runtimeSrc = "";

    if (source) {
      runtimeSrc = source.replace(/tk9-slide-cart-stale-guard\.js(?:\?[^#]*)?/i, "tk9-slide-cart-v2.js?v=" + CURRENT_SLIDE_CART_VERSION);
    } else {
      var existingRuntime = document.querySelector('script[src*="tk9-slide-cart-v2.js"]');
      if (existingRuntime && existingRuntime.src) {
        runtimeSrc = existingRuntime.src.replace(/\?[^#]*/, "?v=" + CURRENT_SLIDE_CART_VERSION);
      }
    }

    if (!runtimeSrc) return;
    var script = document.createElement("script");
    script.src = runtimeSrc;
    script.defer = true;
    script.async = false;
    script.setAttribute("data-tk9-slide-cart-processing-cutoff-fallback", CURRENT_SLIDE_CART_VERSION);
    (document.head || document.documentElement).appendChild(script);
  }

  var scheduled = false;
  function scheduleRepair() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      repair();
    });
  }

  function bind() {
    injectPdpPatchSizeOverrideCss();
    injectSizeClarityCss();
    scheduleRepair();
    window.setTimeout(loadCurrentSlideCartRuntime, 0);
    window.setTimeout(loadCurrentSlideCartRuntime, 800);
    window.setTimeout(loadCurrentSlideCartRuntime, 2500);
    document.addEventListener("change", function (event) {
      if (event.target && event.target.matches && event.target.matches("[data-tk9-offer-variant]")) {
        window.setTimeout(scheduleRepair, 0);
      }
    }, true);
    document.addEventListener("click", function () {
      window.setTimeout(scheduleRepair, 250);
      window.setTimeout(scheduleRepair, 900);
    }, true);
    var observer = new MutationObserver(scheduleRepair);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setInterval(scheduleRepair, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind, { once: true });
  } else {
    bind();
  }
})();
